<template>
    <div class="result-detail">
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-communcation-icon01.svg" alt="*" />あなたのコミュニケーション
					</span>
				</div><!-- end .type -->
				<div class="cover">
					積極型{{communicateResult.percentageLeft}}%、独立型{{communicateResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>今の自分らしさとは逆のコミュニケーション気質を備えることも考えよう</h2>
				<img src="../assets/result-detail-communication-outright01.svg" alt="*" class="visual" />
				<div class="caption">
					あなたは自分の殻をもっと破っていき、他者と関わることで、物事をどんどん好転させることができる
				</div><!-- end .caption -->
				<p>3番目はコミュニケーションの特性を分析しました。自分のコミュニケーションの能力や癖は、内向的(もしくは外向的)気質を掛け合わさり、恋愛からビジネスまで、幅広い社会活動の結果に影響を与えるからです。</p>
				<p>単純に言えば、内向的な人が好かれるコミュニケーションと、外向的な人が好かれるコミュニケーションはまったく違います。あなたが内向的な人にも関わらず、外向的な人のコミュニケーションをお手本にしていると、自分の個性を伸ばせずに、苦しむことになるでしょう。</p>
				<p>あなたのコミュニケーション独立型{{communicateResult.percentageRight}}%という結果は、正直、外向的な性質からすれば、「非常にもったいない」と言えるでしょう。あなたは、まだまだ様々な人間関係で、今よりもずっと素敵な経験をできる可能性が非常に高いと言えます。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>多様な人間関係に巻き込まれる経験を増やせば、あなたの外向性は、高い外交力へ生まれ変わる</h2>
				<img src="../assets/result-detail-communication-outright02.svg" alt="*" class="visual" />
				<div class="caption">
					日頃から自分の余裕に注目すれば、あなたの内向性と潜在意識の特徴が相乗効果を発揮する。
				</div><!-- end .caption -->
				<p>多くの外向性における勘違いの一つが、「外向性が高い＝コミュ力が高い」というものです。外向性があるからといって、周囲の人間と適切に過ごす外交力・社交力が高いわけではありません。</p>
				<p>外向性とは、コミュニケーションにおけるマインドセットの1つです。外向性が高いあなたは、瞬発的に相手の懐に入るマインドを、内向型の人よりもずっと持っています。</p>
				<p>しかし、実質、人の懐に入り、その人に好かれるということにおいては、話す力、理解力、雰囲気など、様々なコミュニケーションスキルが必要になります。</p>
				<p>外向性が高い人が、コミュニケーションスキルを高めるには、とにかく多様な人間関係に関わることが大事です。その際は、(1)相手を喜ばせること、(2)相手を理解すること、(3)相手の本質的な部分に興味を示そうとすること、この3つを意識してみて下さい。</p>
				<p>相手の気持ちが分からなくても、相手の言葉の意味が分からなくても大丈夫です。大事なのは、寄り添う姿勢、相手の立場を真剣に考えようとする努力です。外向的かつコミュニケーションが独立型の人は、相手に寄り添う姿勢と努力を示すだけで、人間関係の結果が大きく好転します。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>自己否定の環境は、あなたにとって最高のターニングポイントとなる</h2>
				<img src="../assets/result-detail-communication-outright03.svg" alt="*" class="visual" />
				<div class="caption">
					自己否定してくれる意見や他人は、自分に変革を与えてくれる有難い存在だと認知しよう
				</div><!-- end .caption -->
				<p>外向度が高く、独立型のあなたは、あなたが自分で思っている以上に、周囲から「自己中心的」だと思われています。あなたは、他人の視点や感覚を捉えるのが不得意で、あなたが知らない間に、勘違いを起こしていることが多々あります。</p>
				<p>外向型でなおかつ、コミュニケーションが独立型のあなたは、自己否定を受け入れるかどうかのマインドセットが非常に大切です。逆に、自己否定を受け入れることをしなければ、ますます独りよがりになっていきます。</p>
				<p>ですから、他人から積極的に批判や指摘を得られる環境を作り、自信を見直すようにしていきましょう。相手が本音を言いやすいような雰囲気を作ることを普段から心がけてみて下さい。</p>
				<p>やはり、あなたは外向度が高いタイプなので、どんどん外に出て、どんどん人に会うことが、強みになっていきます。そして、今回お伝えしたポイントを踏まえれば、周囲の環境や人間とうまく関わりながら、自分を強く打ち出すことができるようになります。</p>
				<p>外向型が高く、コミュニケーションが独立型のあなたが、相手に寄り添う姿勢と努力、自己否定を受け入れる環境で成長を促せば、良いリーダーとして求められることが非常に多くなるでしょう。</p>
			</div><!-- end .sentence -->
		</div><!-- end .guidance -->
    </div><!-- end .result-index -->				
</template>

<script>


export default {
	name: 'ResultDetailCommunicationInRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
